import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Col, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

function QuotePendingModal({ isOpen, toggle, revisionId, requestId }) {
  const navigate = useNavigate();
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="md">
      <ModalHeader toggle={toggle} className="d-flex justify-content-between">
        <span className="h5 fw-semibold">Quote Pending</span>
      </ModalHeader>
      <ModalBody>
        <div className="d-flex flex-column align-items-start gap-3">
          <span>
            Quote information available from booking responsible. Do you want to
            select the appropriate quote?
          </span>
        </div>
      </ModalBody>
      <ModalFooter className="d-flex flex-row justify-content-between w-100 gap-2">
        <Col className="w-100">
          <button
            type="button"
            className="custom-btn w-100"
            onClick={() =>
              navigate(`/travel-request/options/${requestId}/${revisionId}`)
            }
          >
            Yes
          </button>
        </Col>
        <Col className="w-100">
          <button
            type="button"
            className="custom-danger-btn w-100"
            onClick={toggle}
          >
            No
          </button>
        </Col>
      </ModalFooter>
    </Modal>
  );
}

export default QuotePendingModal;
